import { useEffect, useRef } from 'react'
import { Users2 } from 'lucide-react'
import { LEADERSHIP } from '../data/leadership'
import { setupPanelReveals } from '../lib/motion'

const LeadershipTimeline: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const node = ref.current
    if (!node) return
    return setupPanelReveals(node, { drawLine: true })
  }, [])

  return (
    <div ref={ref} className="relative pl-7 md:pl-10">
      <div
        className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-neutral-200 dark:bg-white/10"
        aria-hidden="true"
      />
      <div
        data-timeline-line
        className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-primary-500/70"
        aria-hidden="true"
      />

      <div data-reveal-item className="relative mb-6 flex items-center gap-2.5">
        <span className="absolute -left-7 md:-left-10 top-[5px] h-[9px] w-[9px] rounded-full bg-primary-500" />
        <Users2 size={15} className="text-primary-500" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-400 dark:text-neutral-500">
          Clubs & communities
        </span>
      </div>

      {LEADERSHIP.map((item) => (
        <div key={`${item.org}-${item.title}`} data-reveal-item className="relative mb-12 last:mb-0">
          <span className="absolute -left-7 md:-left-10 top-0 flex items-center justify-center w-[15px] h-[15px] md:w-[19px] md:h-[19px] rounded-full bg-primary-500 ring-4 ring-primary-500/15" />

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-3">
            <p className="font-mono text-xs uppercase tracking-[0.16em] text-neutral-400 dark:text-neutral-500">
              {item.period}
            </p>
            {item.current && (
              <span className="inline-flex items-center rounded-md bg-primary-500/10 text-primary-600 dark:text-primary-400 px-2.5 py-1 text-xs font-mono">
                Current
              </span>
            )}
          </div>

          <h3 className="font-display text-xl font-semibold tracking-tight sm:text-2xl">
            {item.title}
            <span className="text-neutral-400 dark:text-neutral-500"> — {item.org}</span>
          </h3>

          <ul className="mt-5 grid gap-3 max-w-4xl">
            {item.details.map((detail) => (
              <li
                key={detail}
                className="flex items-start gap-3 text-sm text-neutral-600 dark:text-neutral-300 leading-relaxed"
              >
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0" />
                {detail}
              </li>
            ))}
          </ul>

          <div className="mt-6 flex flex-wrap gap-2">
            {item.tags.map((tag) => (
              <span
                key={tag}
                className="inline-flex items-center rounded-md border border-neutral-200 dark:border-white/8 px-2.5 py-1 font-mono text-xs text-neutral-500 dark:text-neutral-400"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export default LeadershipTimeline